export const DAYS_OF_WEEK = ['MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY','SUNDAY'] as const;
export type DayOfWeek = typeof DAYS_OF_WEEK[number];
export interface DayHours { isOpen: boolean; openHour: number; openMinute: number; closeHour: number; closeMinute: number }
export type EditableHours = Record<DayOfWeek, DayHours>;
export interface GoogleHoursPeriod {
  openDay: string; closeDay: string;
  openTime: {hours?: number; minutes?: number}; closeTime: {hours?: number; minutes?: number};
}
export interface GoogleHours { periods?: GoogleHoursPeriod[] }
export function parseGoogleHours(hours: GoogleHours | null | undefined): EditableHours {
  return Object.fromEntries(DAYS_OF_WEEK.map(day => {
    const period = hours?.periods?.find(p => p.openDay === day);
    return [day, {isOpen: !!period, openHour: period ? period.openTime?.hours ?? 0 : 8,
      openMinute: period?.openTime?.minutes ?? 0, closeHour: period ? period.closeTime?.hours ?? 0 : 17,
      closeMinute: period?.closeTime?.minutes ?? 0}];
  })) as EditableHours;
}
/** The simple editor cannot safely flatten split, overnight, or 24-hour periods. */
export function hasComplexHours(hours: GoogleHours | null | undefined, day: DayOfWeek): boolean {
  const periods = hours?.periods?.filter(p => p.openDay === day) || [];
  return periods.length > 1 || periods.some(p => p.closeDay !== day ||
    ((p.closeTime?.hours ?? 0) * 60 + (p.closeTime?.minutes ?? 0)) <= ((p.openTime?.hours ?? 0) * 60 + (p.openTime?.minutes ?? 0))) ||
    !!hours?.periods?.some(p => p.closeDay === day && p.openDay !== day);
}
export function replaceDayHours(hours: GoogleHours | null | undefined, day: DayOfWeek, value: DayHours): GoogleHours {
  if (hasComplexHours(hours, day)) return hours || {periods: []};
  return {...hours, periods: [
    ...(hours?.periods || []).filter(p => p.openDay !== day),
    ...(value.isOpen ? [{openDay: day, closeDay: day, openTime: {hours: value.openHour, minutes: value.openMinute},
      closeTime: {hours: value.closeHour, minutes: value.closeMinute}}] : []),
  ]};
}
